import script from "./UnmappedBadges.vue?vue&type=script&setup=true&lang=js"
export * from "./UnmappedBadges.vue?vue&type=script&setup=true&lang=js"

import "./UnmappedBadges.vue?vue&type=style&index=0&id=32cce3ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32cce3ac"]])

export default __exports__